import React from 'react';
import Switch from 'apollo-react/components/Switch';
import FieldWrapper from '../../fields/FieldWrapper';

const SwitchFieldInput = ({
  id,
  label,
  value,
  onChange,
  helperText,
  disabled,
  columnStyle,
}) => {
  return (
    <FieldWrapper style={columnStyle}>
      <Switch
        id={id}
        name={id}
        label={label}
        checked={value}
        onChange={onChange}
        helperText={helperText}
        disabled={disabled}
      />
    </FieldWrapper>
  );
};

export default SwitchFieldInput;
